import { Command } from 'commands/Commands';

export class DemoteEditor extends Command {
  type: string = 'Member.DemoteEditor';
  priority: number = 100;
}
